import { Link } from 'react-router-dom';
import { passportActions, passportHotline } from '@/mocks/trace-passport';

export default function PassportActionBar() {
  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40 bg-background-50/95 backdrop-blur-md border-t border-background-200">
      <div className="px-4 py-2.5 flex items-center gap-2">
        {passportActions.map((action) => (
          <Link
            key={action.key}
            to={action.href}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-1 rounded-md text-foreground-600 whitespace-nowrap cursor-pointer transition-colors hover:text-secondary-700"
          >
            <i className={`${action.icon} text-lg`}></i>
            <span className="text-[11px]">{action.label}</span>
          </Link>
        ))}
        <a
          href={`tel:${passportHotline.tel}`}
          className="shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-secondary-500 text-background-50 text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-secondary-600"
        >
          <i className="ri-phone-fill"></i>
          {passportHotline.label}
        </a>
      </div>
    </div>
  );
}